<div class="edit-page-root-container order-summary-root-container">
    <div class="page-content">
      <div class="page-header">
        <button mat-button class="nav-button" (click)="navBack()">
          <mat-icon>arrow_back</mat-icon>
        </button>
        <div class="title">Order Summary <Span>[{{orderInfo.order_id}}]</Span></div>
        <div class="action-btn-container">
          <button mat-flat-button class="action-btn btn-back" (click)="navBack()">Back</button>
        </div>
      </div>
  
      <div class="page-details">
        <form class="edit-form">
          <div class="detail-section">
            <div class="content-container">
    
              <!-- Order Details -->
            <div class="order-parent" style="display:flex; gap:5px;flex:1;">
              <div class="summary-block order-summary-block">
                <div class="box-header">Order Details</div>
                <div class="box-content">
                 
                    <div class="order-details-row">
                      <div class="order-icon">
                        <mat-icon class="order-dtl-icon">folder</mat-icon>
                      </div>
                      <div class="order-label">: {{ orderInfo.order_no ?? '-' }}</div>
                    </div>
                    <div class="order-details-row">
                      <div class="order-icon">
                        <mat-icon class="order-dtl-icon">shop</mat-icon>
                      </div>
                      <div class="order-label">: {{orderInfo.shop_name ?? '-'}}</div>
                    </div>
                    <div class="order-details-row">
                        <div class="order-icon">
                          <mat-icon class="order-dtl-icon">shop</mat-icon>
                        </div>
                        <div class="order-label">: {{orderInfo.station_name ?? '-' }}</div>
                      </div>
                    <div class="order-details-row">
                      <div class="order-icon">
                        <mat-icon class="order-dtl-icon">date_range</mat-icon>
                      </div>
                      <div class="order-label">: {{ orderInfo.order_time ? (orderInfo.order_time | date: 'dd-MM-yyyy hh:mm') : '-' }}
                      </div>
                  
                  </div>
                </div>
              </div>
  
              <!-- Customer Details -->
              <div class="summary-block">
                <div class="box-header">Customer Details</div>
                <div class="box-content">
                
                    <div class="customer-details-row">
                      <div class="customer-icon">
                        <mat-icon class="order-dtl-icon">account_circle</mat-icon>
                      </div>
                      <div class="customer-label">: {{orderInfo.customer_dtl?.first_name  ?? '-'}}</div>
                    </div>
                  
                    <div class="customer-details-row">
                      <div class="customer-icon">
                        <mat-icon class="order-dtl-icon">email</mat-icon>
                      </div>
                      <div class="customer-label">: {{orderInfo.customer_dtl?.email ?? '-'}} </div>
                    </div>
                    <div class="customer-details-row">
                      <div class="customer-icon">
                        <mat-icon class="order-dtl-icon">phone</mat-icon>
                      </div>
                      <div class="customer-label">: {{orderInfo.customer_dtl?.phone_number ?? '-'}}</div>
                    </div>
                  </div>
                
              </div>
  
              <!-- Timeline -->
              <div class="summary-block payment-detail-block" style="max-width: 500px;">
                <div class="box-header">Order Payments</div>
                <div class="box-content">
                  
                    <div class="payment-row status-row">
                      <div class="payment-icon status-icon">
                        <mat-icon class="order-dtl-icon">account_circle</mat-icon>
                      </div>
                      <div class="info-container"> <span class="label">Status :</span>     <span [ngClass]="{ 'closed': orderInfo.status === 3, 'refunded': orderInfo.status === 4 }">{{orderInfo.status_text}}</span></div>
                    </div>
                    <div class="payment-row total-tax-row">
                      <div class="payment-icon ">
                        <mat-icon class="order-dtl-icon">account_circle</mat-icon>
                      </div>
                      <div class="info-container"><div class="total-info"><span class="label">Total :</span> <span>{{orderInfo.total_amount | currency}}</span></div>  <div class="tax-info"><span class="label">Tax :</span>  <span>{{orderInfo.total_tax | currency}}</span></div>  </div>
                    </div>
                    
                  <div class="payment-row payment-mode-row">
                    <div class="payment-icon">
                      <mat-icon class="order-dtl-icon">account_circle</mat-icon>
                    </div>
                    <div class="info-container">
                      
                        <div class="payment-mode-div" *ngIf="totalCash > 0">
                          <span class="label">Cash : </span> <span  class="amount">{{ totalCash | currency }}</span>
                        </div>
                        <div class="payment-mode-div" *ngIf="totalCard > 0">
                          <span class="label">Card : </span> <span  class="amount">{{ totalCard | currency }}</span>
                        </div>
                        <div class="payment-mode-div" *ngIf="totalVoucher > 0">
                          <span class="label">Voucher : </span> <span  class="amount">{{ totalVoucher | currency }}</span>
                        </div>
                        <div class="payment-mode-div" *ngIf="totalCompany > 0">
                          <span class="label">Company : </span> <span class="amount">{{ totalCompany | currency }}</span>
                        </div>
                        <div class="payment-mode-div" *ngIf="balance > 0">
                          <span class="label">Balance : </span> <span class="amount">{{ balance | currency }}</span>
                        </div>
                       
                      
                    </div>
                  </div>

                  <div class="payment-row paid-details-row">
                    <div class="payment-icon status-icon">
                      <mat-icon class="order-dtl-icon">account_circle</mat-icon>
                    </div>
                    <div class="info-container"> <span class="label">Paid On :</span>      <span>{{payment_time  | date: 'dd-MM-yyyy hh:mm'}}</span></div>
                  </div>
                  <div class="payment-row total-refund-details-row"  *ngIf="totalRefund > 0">
                    <div class="payment-icon ">
                      <mat-icon class="order-dtl-icon">account_circle</mat-icon>
                    </div>
                    <div class="info-container"><div class="total-refund-info"> <span class="label">Refunds : </span> <span  class="amount">{{ totalRefund | currency }}</span></div>  <div class="date-info"><span>{{refund_payment_time  | date: 'dd-MM-yyyy hh:mm'}}</span></div>  </div>
                  </div>
                 
                </div>
              </div>
            </div>
            <!-- <div class="order-remmarks" >
              <div class="remarks" [innerHtml]="getOrderRemarks(orderInfo)"></div>
             </div> -->
             <div class="order-remmarks" 
     *ngIf="(orderInfo.remarks ?? '').trim().length > 0">
  <div class="remarks" [innerHtml]="getOrderRemarks(orderInfo)"></div>
</div>
              <!-- Order Summary Table -->
              <div class="order-table">
                <div class="padd-10">
                  <div class="invoice-model">
                    <table class="table table-bordered invoice-table-custom" >
                      <thead class="invoice">
                        <tr class="head">
                          <td class="text-left">Item</td>
                          <td class="text-left">Category</td>
                          <td style="text-align: right">Quantity</td>
                          <td style="text-align: right">Unit Price</td>
                          <td style="text-align: right">Discount</td>
                          <td style="text-align: right">Total</td>
                        </tr>
                      </thead>
                      <tbody class="tbody">
                        <!-- Main Items Loop -->
                        <ng-container *ngFor="let item of orderInfo.order_dtl">
                          <!-- Main Item Row -->
                          <tr>
                            <td class="text-left">{{ item.sale_item_name }}</td>
                            <td class="text-left">{{ item.sub_class_name }}</td>
                            <td style="text-align: right">{{ item.qty }}</td>
                            <td style="text-align: right">{{ item.fixed_price | currency }}</td>
                            <td style="text-align: right">{{ item.discount_amount | currency }}</td>
                            <td style="text-align: right">{{ item.item_total | currency }}</td>
                          </tr>
                      
                          <!-- Customizations for Main Item -->
                          <ng-container *ngIf="item.customizations">
                            <tr *ngFor="let customization of item.customizations">
                              <td colspan=2 class="text-left" style="padding-left: 35px;">
                                <div style="display: flex; align-items: center;">
                                 <mat-icon>filter_tilt_shift</mat-icon>
                                <span style="margin-left: 10px;">{{ customization.sale_item_name }}</span>
                                </div>
                                
                              </td>
                              <td style="text-align: right">{{ customization.qty }}</td>
                              <td style="text-align: right">{{ customization.fixed_price | currency }}</td>
                              <td style="text-align: right">{{ customization.total_discount_amount | currency }}</td>
                              <td style="text-align: right">{{ customization.item_total | currency }}</td>
                              
                            </tr>
                          </ng-container>
                      
                          <!-- Combo Items -->
                          <ng-container *ngIf="item.combo_items">
                            <ng-container *ngFor="let comboItem of item.combo_items">
                              <!-- Combo Item Row -->
                              <tr>
                                <td colspan="2" class="text-left" style="padding-left: 35px;">
                                  <div style="display: flex; align-items: center;">
                                    <mat-icon>brightness_1</mat-icon>
                                    <span style="margin-left: 10px;"> {{ comboItem.sale_item_name }}</span>
                                  </div>
                                </td>
                                <td style="text-align: right">{{ comboItem.qty }}</td>
                                <td style="text-align: right">{{ comboItem.fixed_price | currency }}</td>
                                <td style="text-align: right">{{ comboItem.total_discount_amount | currency }}</td>
                                <td style="text-align: right">{{ comboItem.item_total | currency }}</td>
                                
                              </tr>
                      
                              <!-- Combo Item Customizations -->
                              <ng-container *ngIf="comboItem.customizations">
                                <tr *ngFor="let comboCustom of comboItem.customizations">
                                  <td colspan=2 class="text-left" style="padding-left: 60px;">
                                    <div style="display: flex; align-items: center;">
                                     <mat-icon>filter_tilt_shift</mat-icon>
                                    <span style="margin-left: 10px;">{{ comboCustom.sale_item_name }}</span>
                                    </div>
                                    
                                  </td>
                                
                                  <td style="text-align: right">{{ comboCustom.qty }}</td>
                                  <td style="text-align: right">{{ comboCustom.fixed_price | currency }}</td>
                                  <td style="text-align: right">{{ comboCustom.total_discount_amount | currency }}</td>
                                  <td style="text-align: right">{{ comboCustom.item_total | currency }}</td>
                                 
                                </tr>
                                <tr *ngIf="item.remarks !==undefined && item.remarks.length>0">
                                  <td colspan="6">
                                    **
                                    {{item.remarks}}
                                  </td>
                                </tr>
                              </ng-container>
                            </ng-container>
                          </ng-container>
                        </ng-container>
                      
                        <!-- Total Rows -->
                        <tr>
                          <td colspan="5" style="text-align: right">Total Amount</td>
                          <td style="text-align: right">{{ orderInfo.total_amount | currency }}</td>
                        </tr>
                        <tr>
                          <td colspan="5" style="text-align: right">Discount</td>
                          <td style="text-align: right">{{ orderInfo.bill_discount_amount | currency }}</td>
                        </tr>
                        <tr>
                          <td colspan="5" style="text-align: right">Round Off</td>
                          <td style="text-align: right">{{ orderInfo.final_round_amount | currency }}</td>
                        </tr>
                        <tr>
                          <td colspan="5" style="text-align: right">Net Amount</td>
                          <td style="text-align: right">{{ orderInfo.final_amount | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  